import React, {} from "react";
import { AppBar, Toolbar, Typography, Link, Container, IconButton, Tooltip } from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import logo from "../images/icon.png";
import AddchartIcon from '@mui/icons-material/Addchart';
import HomeIcon from '@mui/icons-material/Home';
import LoginLogoutButton from "./auth/LoginButton";
import { useUserInfoContext } from "../contexts/UserInfoContext";
import { UserButton } from "./auth/UserButton";
import UserUtils from "../utils/userUtils";

export const Navbar = (props) => {
  const {userInfo, isAuthorized, checkIfUserHasRole} = useUserInfoContext();

  return (
    <AppBar
      position="sticky"
      sx={{backgroundColor: "white", marginBottom: "1em"}}
    >
      <Toolbar sx={{position: "relative", marginLeft: "10%", marginRight: "10%"}} >
        <Link
          component={RouterLink}
          to="/"
          underline="none"
          style={{display: 'flex', flexGrow: 1}}
        >
        <img src={logo} style={{height: "40px", marginTop: "2px", marginRight: "8px"}} alt="levrum logo"/>
        <Typography sx={{color: 'black', fontSize: "1.5rem", marginTop: "2px", paddingTop:"2px"}}>
          Code3 Advisor
        </Typography>
      </Link>

      {isAuthorized &&
      <div>
        <Typography sx={{color: 'black'}}>
          Welcome {userInfo.userName}    
        </Typography>
      </div>
      }

      <div>
        <Tooltip title="Schedules Home">
          <IconButton
            component={RouterLink}
            to="/"
          >
            <HomeIcon/>
          </IconButton>
        </Tooltip>
      </div>
      {checkIfUserHasRole(UserUtils.RoleObjects['powerUser'].name) &&
        <div>
          <Tooltip title="Generate New Schedules">
            <IconButton
              component={RouterLink}
              to="/optimizations"
            >
              <AddchartIcon/>
            </IconButton>
          </Tooltip>
        </div>
      }

      {!isAuthorized ?
       <div>
        <LoginLogoutButton />
      </div> : 
      <div>
        <UserButton />
      </div>
      }
    

      {/* <div>
        <Link sx={{color: 'black', fontSize: "1rem", paddingRight: ".5em" }} underline="none" component={RouterLink} to="/">
          Solutions
        </Link>
      </div>
      <div>
        <Link sx={{color: 'black', fontSize: "1rem", }} underline="none" component={RouterLink} to="/optimizations">
          Optimizations
        </Link>
      </div> */}
      </Toolbar>
    
    </AppBar>
  )
}